module.exports = __webpack_public_path__ + "static/media/hurricane_cable.761e281a.jpg";